import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import projectLogo from "../assets/Logo.png";
// import developerLogo from "../assets/DeveloperLogo.svg";
import monogram1 from "../assets/monogram1.jpeg";
import monogram2 from "../assets/monogram2.webp";
import monogram3 from "../assets/monogram3.jpg";
import monogram4 from "../assets/monogram4.jpg";
import monogram5 from "../assets/monogram5.jpeg";
import mapImage from "../assets/Map.png";
import {
  MapPinIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  PlayIcon,
  Bars3Icon,
  XMarkIcon,
  PhoneIcon,
} from "@heroicons/react/24/solid";

const navItems = [
  { id: "home", label: "Home", iconClass: "nav-mi-home", homeOnly: true },
  { id: "price", label: "Price", iconClass: "nav-mi-price" },
  { id: "sitefloorplan", label: "Site & Floor Plan", iconClass: "nav-mi-site-plan" },
  { id: "amenities", label: "Amenities", iconClass: "nav-mi-amenities" },
  { id: "location", label: "Location", iconClass: "nav-mi-location" },
  { id: "sitevisit", label: "Virtual Tour Visit", iconClass: "nav-mi-site-visit" },
  { id: "sitevisit", label: "Brochure", iconClass: "nav-mi-download", opensBrochure: true },
];

const pricingRows = [
  { type: "3.5 BHK", area: "On Request", price: "₹5.75 Cr*" },
  { type: "4 BHK", area: "On Request", price: "On Request" },
];

const floorPlans = [
  { label: "Master Plan", img: monogram2 },
  { label: "3.5 BHK", img: monogram3 },
  { label: "4 BHK", img: monogram4 },
];

const amenityGroups = [
  {
    title: "The E-Deck — Elevated Leisure",
    items: [
      "Community Green & Botanical Walks",
      "Celebration Pavilion & Open Music Deck",
      "Fitness Track & Sports Arena",
      "Senior Citizen Lounge & Zen Garden",
      "Kids’ Play Retreat & Pet Park",
      "Emergency Care Room",
    ],
  },
  {
    title: "The Monogram Standard — Signature Privileges",
    items: ["Card Room & Banquet Salon", "Padel Court", "Guest Suites"],
  },
  {
    title: "The Rooftop — A World of Indulgence",
    items: [
      "Infinity Sky Pool & Poolside Cabana",
      "Sky Lounge Pavilion & Rooftop Celebration Lawn",
      "Gourmet Barbecue & Dining Deck",
      "Yoga & Meditation Lawn",
      "Amphitheater Plaza & Activity Zone",
      "Covered Jacuzzi & Stargazing Corner",
    ],
  },
];

const faqs = [
  {
    q: "Where is The Monogram Collection located?",
    a: "The Monogram Collection is located at Lokhandwala, near Infiniti Mall, Link Road, Andheri West, Mumbai – 400102.",
  },
  {
    q: "What configurations are available at The Monogram Collection?",
    a: "The project offers bespoke 3.5 & 4 BHK luxury residences with personalised layouts.",
  },
  {
    q: "What is the starting price of The Monogram Collection?",
    a: "Prices start at ₹5.75 Cr* plus taxes. Enquire now for the complete cost sheet.",
  },
  {
    q: "What is the MahaRERA number of the project?",
    a: "The Monogram Collection is registered under MahaRERA No. PM1180002502479.",
  },
  {
    q: "What amenities does The Monogram Collection offer?",
    a: "The project offers 40+ amenities, including an infinity sky pool, English bar, padel court, banquet salon, sports arena, kids’ play retreat and much more.",
  },
  {
    q: "Who is the developer of The Monogram Collection?",
    a: "The project is developed by Veena Developers, a trusted name with 40+ delivered projects across Mumbai.",
  },
];

const nearbyGroups = [
  { title: "Shopping & Entertainment", items: ["Infiniti Mall, Fun Republic Mall & Citi Mall", "D Mart & Lokhandwala Market"] },
  { title: "Metro & Transit", items: ["Oshiwara & Lower Oshiwara Metro Stations", "Andheri West & D N Nagar Metro Stations", "Andheri Railway Station", "Upcoming Coastal Road & Metro connectivity"] },
  { title: "Healthcare", items: ["Kokilaben Dhirubhai Ambani Hospital"] },
  { title: "Schools", items: ["JBCN International School & RIMS International School"] },
  { title: "Hotels & Leisure", items: ["JW Marriott, Novotel & Moxy Hotel", "Jogger’s Park & Andheri Sports Complex"] },
];

const promiseItems = [
  { label: "Instant Call Back", iconClass: "nav-mi-support-call" },
  { label: "Free Site Visit", iconClass: "nav-mi-support-visit" },
  { label: "Unmatched Price", iconClass: "nav-mi-support-price" },
];

const buttonClass =
  "cta-hover rounded-md bg-[#633F2A] px-5 py-2 text-base font-semibold text-white hover:bg-[#633F2A]";
const sectionClass = "mt-4 rounded-none bg-white p-4 shadow-sm md:rounded";
const webhookUrl =
  "https://script.google.com/macros/s/AKfycbxTrPUIKN5-vZAda8_PTCJ_Fdpry7a9P-SKrYNoXGuWIeRHnmb-AptkapEqihZdJiik2g/exec";

function formatPhoneNumber(countryCode, phone) {
  const callingCode = countryCode.match(/\+(\d+)/)?.[1] || "";
  return `${callingCode}${phone.replace(/\D/g, "")}`;
}

function RobotCheckbox({ checked, onChange }) {
  return (
    <label className="flex min-h-[78px] w-[304px] cursor-pointer items-center justify-between border border-slate-300 bg-[#fafafa] px-4 shadow-sm">
      <span className="flex items-center gap-4">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="h-8 w-8 cursor-pointer accent-[#633F2A]"
        />
        <span className="text-base text-slate-900">I&apos;m not a robot</span>
      </span>
      <span className="flex flex-col items-center text-slate-500" aria-hidden="true">
        <span className="text-3xl leading-none text-[#633F2A]">✓</span>
        <span className="mt-1 text-[10px]">Verification</span>
      </span>
    </label>
  );
}

async function submitLeadForm({ name, email, phone, message, pageUrl }) {
  const payload = new URLSearchParams({
    name: name.trim(),
    email: email.trim(),
    phone: phone.trim(),
    message,
    campaignName: "Monogram Collection by Veena",
    pageUrl,
  });

  await fetch(webhookUrl, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    body: payload.toString(),
  });
}

function RightSidebar({
  onOpenModal,
  formData,
  onFieldChange,
  onSubmit,
  isSubmitting,
  robotConfirmed,
  robotError,
  onRobotChange,
}) {
  return (
    <aside className="hidden xl:fixed xl:right-0 xl:top-0 xl:z-40 xl:block xl:h-screen xl:w-[390px] xl:overflow-y-auto xl:border-l xl:border-slate-300 xl:bg-white xl:p-4">
      <div className="-mx-4 -mt-4 bg-slate-100 pb-2">
        <div className="mx-auto flex w-fit overflow-hidden rounded-b-2xl bg-[#242424] text-white">
          <button
            type="button"
            onClick={onOpenModal}
            className="border-r border-white/70 px-4 py-2.5 text-base font-medium"
          >
            Organize Site Visit
          </button>
          <a
            href="tel:+918689966899"
            className="flex items-center gap-1 px-4 py-2.5 text-base font-semibold"
          >
            <PhoneIcon className="h-5 w-5" />
            +91 8689966899
          </a>
        </div>
        <button
          type="button"
          onClick={onOpenModal}
          className="cta-hover mx-auto mt-1.5 flex items-center gap-1 rounded bg-[#633F2A] px-5 py-2 text-base font-semibold text-white"
        >
          <PhoneIcon className="h-5 w-5" />
          Request Call Back
        </button>
      </div>

      <h3 className="mt-3 text-center text-2xl font-bold text-slate-900">
        Get The Best Quote
      </h3>

      <form className="mt-7 space-y-4" onSubmit={onSubmit}>
        <input
          required
          value={formData.name}
          onChange={(e) => onFieldChange("name", e.target.value)}
          placeholder="Name"
          className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-600 outline-none"
        />
        <input
          type="email"
          required
          value={formData.email}
          onChange={(e) => onFieldChange("email", e.target.value)}
          placeholder="Email Address"
          className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-600 outline-none"
        />
        <div className="grid grid-cols-2 gap-2">
          <select
            value={formData.countryCode}
            onChange={(e) => onFieldChange("countryCode", e.target.value)}
            className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-700 outline-none"
          >
            <option>India (+91)</option>
            <option>United Arab Emirates (+971)</option>
            <option>United States (+1)</option>
          </select>
          <input
            required
            value={formData.phone}
            onChange={(e) => onFieldChange("phone", e.target.value)}
            placeholder="Mobile No"
            className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-600 outline-none"
          />
        </div>
        <select
          required
          value={formData.configuration}
          onChange={(e) => onFieldChange("configuration", e.target.value)}
          className="w-full border-b border-slate-300 bg-transparent px-2 py-3 text-base text-slate-700 outline-none"
        >
          <option value="">Select Configuration</option>
          <option>3.5 BHK</option>
          <option>4 BHK</option>
        </select>
        <div className="flex justify-center overflow-hidden">
          <RobotCheckbox checked={robotConfirmed} onChange={onRobotChange} />
        </div>
        {robotError && (
          <p className="text-center text-sm text-red-600">Please confirm that you are not a robot.</p>
        )}
        <button
          type="submit"
          disabled={isSubmitting}
          className="cta-hover rocking-button mx-auto mt-3 block rounded-xl bg-[#633F2A] px-5 py-2 text-base font-semibold text-white"
        >
          {isSubmitting ? "Submitting..." : "Send"}
        </button>
      </form>
    </aside>
  );
}

function Home() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("home");
  const [faqOpen, setFaqOpen] = useState(-1);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isBrochureOpen, setIsBrochureOpen] = useState(false);
  const [isSubmittingSidebar, setIsSubmittingSidebar] = useState(false);
  const [sidebarRobotConfirmed, setSidebarRobotConfirmed] = useState(false);
  const [sidebarRobotError, setSidebarRobotError] = useState(false);

  useEffect(() => {
    let repeatPopupTimer;

    const firstPopupTimer = window.setTimeout(() => {
      setIsBrochureOpen(true);

      repeatPopupTimer = window.setInterval(() => {
        setIsBrochureOpen(true);
      }, 7000);
    }, 3000);

    return () => {
      window.clearTimeout(firstPopupTimer);
      if (repeatPopupTimer) window.clearInterval(repeatPopupTimer);
    };
  }, []);
  const [isSubmittingModal, setIsSubmittingModal] = useState(false);
  const [modalRobotConfirmed, setModalRobotConfirmed] = useState(false);
  const [modalRobotError, setModalRobotError] = useState(false);
  const [sidebarForm, setSidebarForm] = useState({
    name: "",
    email: "",
    countryCode: "India (+91)",
    phone: "",
    configuration: "",
  });
  const [modalForm, setModalForm] = useState({
    name: "",
    email: "",
    countryCode: "India (+91)",
    phone: "",
    configuration: "",
  });

  useEffect(() => {
    if (!isBrochureOpen) {
      setModalRobotConfirmed(false);
      setModalRobotError(false);
    }
  }, [isBrochureOpen]);

  const handleSidebarFieldChange = (field, value) => {
    setSidebarForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleModalFieldChange = (field, value) => {
    setModalForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSidebarSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingSidebar) return;
    if (!sidebarRobotConfirmed) {
      setSidebarRobotError(true);
      return;
    }
    setIsSubmittingSidebar(true);
    try {
      await submitLeadForm({
        name: sidebarForm.name,
        email: sidebarForm.email,
        phone: formatPhoneNumber(sidebarForm.countryCode, sidebarForm.phone),
        message: `Hi, I am interested in The Monogram Collection (${sidebarForm.configuration}). Please share more details.`,
        pageUrl: window.location.href,
      });
      setSidebarForm({
        name: "",
        email: "",
        countryCode: "India (+91)",
        phone: "",
        configuration: "",
      });
      navigate("/thank-you");
    } finally {
      setIsSubmittingSidebar(false);
    }
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingModal) return;
    if (!modalRobotConfirmed) {
      setModalRobotError(true);
      return;
    }
    setIsSubmittingModal(true);
    try {
      await submitLeadForm({
        name: modalForm.name,
        email: modalForm.email,
        phone: formatPhoneNumber(modalForm.countryCode, modalForm.phone),
        message: `Hi, I am interested in The Monogram Collection (${modalForm.configuration}). Please share more details.`,
        pageUrl: window.location.href,
      });
      setModalForm({
        name: "",
        email: "",
        countryCode: "India (+91)",
        phone: "",
        configuration: "",
      });
      setIsBrochureOpen(false);
      navigate("/thank-you");
    } finally {
      setIsSubmittingModal(false);
    }
  };

  return (
    <div className="bg-white">
      <RightSidebar
        onOpenModal={() => setIsBrochureOpen(true)}
        formData={sidebarForm}
        onFieldChange={handleSidebarFieldChange}
        onSubmit={handleSidebarSubmit}
        isSubmitting={isSubmittingSidebar}
        robotConfirmed={sidebarRobotConfirmed}
        robotError={sidebarRobotError}
        onRobotChange={(checked) => {
          setSidebarRobotConfirmed(checked);
          if (checked) setSidebarRobotError(false);
        }}
      />

      <header className="fixed left-0 right-0 top-0 z-50 border-b border-slate-300 bg-white shadow-sm xl:right-[390px]">
        <div className="flex items-stretch bg-white">
          <a href="#home" className="grid w-[160px] place-items-center bg-white px-1 py-1 md:w-[250px]">
            <img
              src={projectLogo}
              alt="The Monogram Collection"
              className="h-[52px] w-[220px] object-contain"
            />
          </a>
          <div className="ml-auto grid place-items-center px-2 lg:hidden">
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen((p) => !p)}
              className="rounded-md border border-slate-300 bg-[#f4f4f4] p-2.5 text-slate-700"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
          <nav className="hidden min-w-0 flex-1 overflow-x-auto bg-white lg:flex">
            {navItems.map((item) => {
              return (
                <a
                  key={item.label}
                  href={`#${item.id}`}
                  onClick={(e) => {
                    if (item.opensBrochure) {
                      e.preventDefault();
                      setIsBrochureOpen(true);
                      return;
                    }
                    setActiveTab(item.id);
                  }}
                  className={`inline-flex items-center whitespace-nowrap border-l border-slate-300 px-3 py-2 text-sm font-medium ${activeTab === item.id && !item.opensBrochure
                    ? "bg-[#633F2A] text-white"
                    : "bg-white text-slate-900"
                    }`}
                  aria-label={item.label}
                >
                  {item.homeOnly ? (
                    <span className={`nav-mi ${item.iconClass}`} aria-hidden="true" />
                  ) : (
                    <span className="flex items-center gap-2">
                      <span className={`nav-mi ${item.iconClass}`} aria-hidden="true" />
                      <span>{item.label}</span>
                    </span>
                  )}
                </a>
              );
            })}
            <div className="grid h-[54px] w-[170px] place-items-center border-l border-slate-300">
              {/* <img
                src={developerLogo}
                alt="Veena Developers"
                className="h-[44px] w-[150px] object-contain"
              /> */}
            </div>
          </nav>
        </div>
        {isMobileMenuOpen && (
          <nav className="border-t border-slate-200 bg-white lg:hidden">
            <div className="grid grid-cols-1">
              {navItems.map((item) => {
                return (
                  <a
                    key={`m-${item.label}`}
                    href={`#${item.id}`}
                    onClick={(e) => {
                      if (item.opensBrochure) {
                        e.preventDefault();
                        setIsBrochureOpen(true);
                      } else {
                        setActiveTab(item.id);
                      }
                      setIsMobileMenuOpen(false);
                    }}
                    className={`inline-flex items-center justify-center gap-1 border-b border-slate-200 px-2 py-2 text-xl font-medium ${activeTab === item.id && !item.opensBrochure
                      ? "bg-[#633F2A] text-white"
                      : "bg-white text-slate-900"
                      }`}
                    aria-label={item.label}
                  >
                    <span className={`nav-mi ${item.iconClass}`} aria-hidden="true" />
                    {!item.homeOnly && <span>{item.label}</span>}
                  </a>
                );
              })}
              <div className="grid place-items-center border-b border-slate-200 py-2">
                {/* <img
                  src={developerLogo}
                  alt="Veena Developers"
                  className="h-[52px] w-auto object-contain"
                /> */}
              </div>
            </div>
          </nav>
        )}
      </header>

      <main className="px-3 pb-8 pt-[72px] lg:pt-[62px] xl:pr-[402px]">
        <section id="home" className="relative -mx-3 overflow-hidden rounded-none bg-white shadow-sm md:mx-0 md:rounded">
          <img
            src={monogram1}
            alt="The Monogram Collection by Veena Developers"
            className="h-[260px] w-full object-cover md:h-[500px] lg:h-[660px]"
          />

          <div className="relative z-10 mx-0 -mt-10 w-auto overflow-hidden rounded-none bg-[white] shadow-lg sm:mx-3 sm:w-[340px] md:rounded-xl lg:absolute lg:left-3 lg:top-3 lg:mx-0 lg:mt-0 lg:w-[325px] lg:rounded-xl xl:w-[380px]">
            <div className="w-full bg-gradient-to-r from-[#633F2A] to-[#633F2A] py-3 text-center text-base font-semibold text-white">
              New Launch — EOI Window Now Open
            </div>
            <div className="px-5 py-4 text-center">
              <h1 className="text-3xl font-bold">The Monogram Collection</h1>
              <p className="mt-1 text-base">
                <span className="font-semibold">by Veena Developers</span>
              </p>
            </div>
            <div className="bg-[#d3d3d5] px-5 py-3 text-base">
              <p className="flex justify-between">
                <span>Land Parcel</span>
                <span className="font-semibold">1.89 Acres*</span>
              </p>
              <p className="mt-1 flex justify-between">
                <span>Possession</span>
                <span className="font-semibold">2029*</span>
              </p>
              <p className="mt-1 flex justify-between">
                <span>Storey</span>
                <span className="font-semibold">G + 36 Floors*</span>
              </p>
              <p className="mt-1 flex justify-between gap-4">
                <span>Location</span>
                <span className="text-right font-semibold">Lokhandwala, Andheri West, Mumbai</span>
              </p>
            </div>
            <div className="p-4">
              <div className="rounded-none border-2 border-dashed border-slate-100 bg-gradient-to-r from-[#633F2A] to-[#633F2A] px-4 py-3 text-center text-base font-semibold leading-normal text-white md:rounded">
                Status: New Launch — EOI Window Now Open
                <br />MahaRERA No.: PM1180002502479
              </div>
              <p className="mt-6 text-center text-base font-semibold">
                Luxury 3.5 &amp; 4 BHK With Deck Residences
              </p>
              <p className="mt-1 text-center text-3xl font-bold">Starting ₹5.75 Cr*</p>
              <button
                type="button"
                onClick={() => setIsBrochureOpen(true)}
                className="cta-hover rocking-button mx-auto mt-4 block rounded-xl bg-[#633F2A] px-5 py-2 text-base font-semibold text-white"
              >
                Enquire Now
              </button>
            </div>
          </div>
        </section>

        <section id="overview" className={sectionClass}>
          <h2 className="text-4xl font-semibold text-[#633F2A]">The Monogram Collection — A New Address at Lokhandwala, Andheri West</h2>
          <p className="mt-3 text-base leading-relaxed">
            The Monogram Collection by Veena Group makes its grand debut at Lokhandwala, Andheri West. This is a new-launch luxury project made for a select few who expect more from the way they live. Here, every home is planned around its owner, not a fixed layout. You decide how each space works for your life, from how you welcome guests to how you relax in private.
          </p>
          <p className="mt-3 text-base leading-relaxed">
            These are expansive 3.5 &amp; 4 BHK residences in a low-density development, which means fewer homes, more privacy and more open space for every family. Grand ceilings, fine materials and thoughtful design come together to create a home that feels truly your own.
          </p>
          <p className="mt-3 text-base leading-relaxed">
            Set in the heart of Andheri West, the project offers easy access to malls, metro stations, top schools, hospitals and business hubs. The world is right at your doorstep, exactly where it belongs.
          </p>
          <h3 className="mt-5 text-xl font-bold">Why Choose The Monogram Collection by Veena Group</h3>
          <ul className="mt-3 grid list-disc gap-2 pl-5 md:grid-cols-2">
            <li>Bespoke 3.5 &amp; 4 BHK homes with Deck planned around you</li>
            <li>Low-density living with high privacy</li>
            <li>Grand ceilings and open, airy interiors</li>
            <li>50+ premium amenities across the project</li>
            <li>Prime Lokhandwala, Andheri West location</li>
            <li>Built by Veena Developers, a trusted name with 40+ projects</li>
          </ul>
          <button
            type="button"
            onClick={() => setIsBrochureOpen(true)}
            className={`${buttonClass} rocking-button mt-4 block mx-auto md:mx-0`}
          >
            Download Brochure
          </button>
        </section>

        <section id="price" className={sectionClass}>
          <h2 className="text-3xl font-medium text-[#633F2A]">The Monogram Collection Price List</h2>
          <p className="mt-3 text-base leading-relaxed">Every home at The Monogram Collection is designed to elevate the way you live. Choose from expansive 3.5 &amp; 4 BHK residences, each offering generous space, natural light and a sense of grandeur.</p>

          <div className="mt-4 space-y-2 lg:hidden">
            {pricingRows.map((row, idx) => (
              <div
                key={`m-${row.type}`}
                className={`border border-slate-200 p-3 text-center ${idx % 2 === 0 ? "bg-[#d9d9dc]" : "bg-[#efeff1]"
                  }`}
              >
                <h3 className="text-2xl font-bold text-slate-800">{row.type}</h3>
                <p className="mt-2 text-lg text-slate-700">
                  {row.area}
                  <span className="text-sm"> (Approx. Area)</span>
                </p>
                <p className="mt-1 text-2xl font-bold text-slate-800">{row.price}</p>
                <button
                  type="button"
                  onClick={() => setIsBrochureOpen(true)}
                  className="cta-hover mt-3 rounded bg-[#633F2A] px-5 py-2 text-base font-semibold text-white"
                >
                  Get Complete Costing Details
                </button>
              </div>
            ))}
          </div>

          <div className="mt-5 hidden gap-6 lg:grid lg:grid-cols-[2fr_1fr]">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse text-base">
                <thead>
                  <tr className="bg-[#efefef]">
                    <th className="border border-slate-300 px-4 py-3 text-left">Type</th>
                    <th className="border border-slate-300 px-4 py-3 text-left">Approx. Area</th>
                    <th className="border border-slate-300 px-4 py-3 text-left">Price</th>
                    <th className="border border-slate-300 px-4 py-3 text-left" />
                  </tr>
                </thead>
                <tbody>
                  {pricingRows.map((row) => (
                    <tr key={row.type} className="bg-[#d1d1d3]">
                      <td className="border border-slate-300 px-4 py-3">{row.type}</td>
                      <td className="border border-slate-300 px-4 py-3">{row.area}</td>
                      <td className="border border-slate-300 px-4 py-3">{row.price}</td>
                      <td className="border border-slate-300 px-4 py-3">
                        <button
                          type="button"
                          onClick={() => setIsBrochureOpen(true)}
                          className="cta-hover rounded bg-[#633F2A] px-5 py-1.5 text-base font-semibold text-white"
                        >
                          Get Costing Details
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="hidden overflow-hidden rounded border-[8px] border-[#633F2A] lg:block">
              <div className="group relative">
                <img
                  src="https://www.dlf-west-park.in/shared_template/img/costingdetails.webp"
                  alt="Costing details"
                  className="h-full w-full object-cover"
                />
                <div className="pointer-events-none absolute inset-0 bg-black/0 transition duration-300 group-hover:bg-black/70" />
                <button
                  type="button"
                  onClick={() => setIsBrochureOpen(true)}
                  className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 border border-white px-7 py-2.5 text-base font-medium tracking-wide text-white opacity-0 transition duration-300 group-hover:opacity-100"
                >
                  ENQUIRE NOW
                </button>
              </div>
              <div className="bg-gradient-to-r from-[#633F2A] to-[#633F2A] py-2 text-center text-sm font-medium text-white">
                Complete Costing Detail
              </div>
            </div>
          </div>
        </section>

        <section id="sitefloorplan" className={sectionClass}>
          <h2 className="text-3xl font-medium text-[#633F2A]">Site &amp; Floor Plan of The Monogram Collection</h2>
          <p className="mt-3 text-base leading-relaxed">Explore thoughtfully designed master plans and floor plans created to make the most of every square foot. Each home offers a smart, spacious layout that can be personalised to suit your lifestyle.</p>
          {/* <div className="mt-4 flex flex-wrap gap-3">
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={buttonClass}>Request Floor Plans</button>
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={buttonClass}>Unlock Master Plan</button>
          </div> */}
          <article className="mx-auto mt-6 w-full max-w-[480px] overflow-hidden border border-slate-200 bg-white shadow-sm">
            <button
              type="button"
              onClick={() => setIsBrochureOpen(true)}
              className="plan-card w-full"
              aria-label="Request the master plan"
            >
              <img
                src={floorPlans[0].img}
                alt={floorPlans[0].label}
                className="h-[260px] w-full object-contain p-3 blur-[1px]"
              />
              <span className="plan-overlay" aria-hidden="true" />
              <span className="plan-action text-base font-medium">UNLOCK MASTER PLAN</span>
            </button>
          </article>

          <h3 className="mt-7 text-2xl font-medium text-slate-900">Floor Plan</h3>
          <div className="mt-5 grid gap-8 md:grid-cols-2">
            {floorPlans.slice(1).map((plan) => (
              <article key={plan.label} className="overflow-hidden border border-slate-200 bg-white shadow-sm">
                <button
                  type="button"
                  onClick={() => setIsBrochureOpen(true)}
                  className="plan-card w-full"
                  aria-label={`Request the ${plan.label} floor plan`}
                >
                  <img src={plan.img} alt={plan.label} className="h-[290px] w-full object-contain p-3 blur-[2px]" />
                  <span className="plan-overlay" aria-hidden="true" />
                  <span className="plan-action text-base font-medium">REQUEST FLOOR PLAN</span>
                </button>
                <div className="bg-[#633F2A] py-3 text-center text-xl font-medium text-white">
                  {plan.label}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="amenities" className={sectionClass}>
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <h2 className="text-3xl font-medium text-[#633F2A]">40+ Amenities. One Magnificent World.</h2>
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={`${buttonClass} self-center md:self-auto`}>
              Download Amenities
            </button>
          </div>
          <p className="mt-3 text-base leading-relaxed">The Monogram Collection brings together leisure, wellness, sport and celebration in one address. With over 40 amenities spread across the project, every day offers something special for every member of the family.</p>
          <div className="mt-5 rounded-none border border-slate-300 p-5 md:rounded-lg">
            <div className="grid gap-7 lg:grid-cols-3">
              {amenityGroups.map((group) => (
                <div key={group.title}>
                  <h3 className="text-lg font-bold text-[#633F2A]">{group.title}</h3>
                  <div className="mt-3 space-y-3">
                    {group.items.map((item) => (
                      <p key={item} className="flex items-start gap-2 text-base font-medium">
                        <ChevronRightIcon className="mt-0.5 h-5 w-5 shrink-0 text-black" />
                        <span>{item}</span>
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* <section id="gallery" className={sectionClass}>
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <h2 className="text-3xl font-medium text-[#633F2A]">The Monogram Collection Gallery</h2>
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={`${buttonClass} self-center md:self-auto`}>
              Download Gallery
            </button>
          </div>

          <div
            className="relative mt-5 lg:hidden"
            onTouchStart={handleGalleryTouchStart}
            onTouchEnd={handleGalleryTouchEnd}
            style={{ touchAction: "pan-y" }}
          >
            <button
              type="button"
              onClick={goToPrevGallery}
              className="absolute left-2 top-1/2 z-10 -translate-y-1/2 rounded-full bg-[#633F2A] px-3.5 py-2.5 text-base text-white"
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
            <img
              src={gallery[galleryStart]}
              alt="Gallery"
              className="aspect-square w-full rounded-none object-cover md:rounded"
            />
            <button
              type="button"
              onClick={goToNextGallery}
              className="absolute right-2 top-1/2 z-10 -translate-y-1/2 rounded-full bg-[#633F2A] px-3.5 py-2.5 text-base text-white"
            >
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </div>

          <div className="relative mt-5 hidden lg:block">
            <button
              type="button"
              onClick={goToPrevGallery}
              className="absolute left-[-8px] top-1/2 z-10 -translate-y-1/2 rounded-full bg-[#633F2A] px-3.5 py-2.5 text-base text-white"
            >
              <ChevronLeftIcon className="h-5 w-5" />
            </button>
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
              {visibleGallery.map((img) => (
                <img key={img} src={img} alt="Gallery" className="aspect-square w-full rounded object-cover" />
              ))}
            </div>
            <button
              type="button"
              onClick={goToNextGallery}
              className="absolute right-[-8px] top-1/2 z-10 -translate-y-1/2 rounded-full bg-[#633F2A] px-3.5 py-2.5 text-base text-white"
            >
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </div>
        </section> */}

        <section id="location" className={sectionClass}>
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <h2 className="text-3xl font-medium text-[#633F2A]">The Address The World Revolves Around</h2>
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={`${buttonClass} self-center md:self-auto`}>
              Get Locations
            </button>
          </div>
          <p className="mt-3 text-base leading-relaxed">The Monogram Collection enjoys one of Andheri West’s most connected locations at Lokhandwala. Malls, metro stations, schools, hospitals and business hubs are all close by, giving you effortless access to everything that matters.</p>
          <p className="mt-2 font-semibold">Address: The Monogram Collection, Near Infiniti Mall, Link Road, Andheri (W), Mumbai – 400102</p>
          <div className="mt-6">
            <h3 className="text-2xl font-medium text-slate-900">Map View</h3>
            <div className="mt-4 w-full max-w-4xl overflow-hidden border border-slate-200 bg-white shadow-sm">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=Near+Infiniti+Mall%2C+Link+Road%2C+Andheri+West%2C+Mumbai+400102"
                target="_blank"
                rel="noreferrer"
                aria-label="Navigate to The Monogram Collection in Google Maps"
              >
                <img
                  src={mapImage}
                  alt="Map showing The Monogram Collection location near Infiniti Mall, Andheri West"
                  className="h-auto w-full cursor-pointer"
                  loading="lazy"
                />
              </a>
            </div>

            <h3 className="mt-7 text-2xl font-medium text-slate-900">Location &amp; Connectivity</h3>
            <div className="mt-5 grid gap-x-10 gap-y-6 md:grid-cols-2 lg:grid-cols-3">
              {nearbyGroups.map((group) => (
                <div key={group.title}>
                  <h4 className="font-bold text-slate-900">{group.title}</h4>
                  <ul className="mt-2 space-y-2 text-base">
                    {group.items.map((item) => (
                      <li key={item} className="flex items-start gap-2">
                        <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#633F2A]" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

        </section>

        <section id="sitevisit" className={sectionClass}>
          <h2 className="text-3xl font-medium text-[#633F2A]">Book Your Private Site Visit</h2>
          <p className="mt-3 text-base leading-relaxed">Discover The Monogram Collection in person. Share your details and our team will arrange a private site visit at your convenience.</p>
          <div className="mt-4 flex flex-wrap gap-3">
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={buttonClass}>Schedule a Site Visit</button>
            <button type="button" onClick={() => setIsBrochureOpen(true)} className={buttonClass}>Request a Call Back</button>
            <a href="https://wa.me/918689966899" target="_blank" rel="noreferrer" className={buttonClass}>WhatsApp Us</a>
          </div>
          <div className="relative mt-4 overflow-hidden">
            <img
              src={monogram5}
              alt="Virtual Site Visit"
              className="h-[360px] w-full object-cover"
            />
            <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 bg-black/50 py-5 text-center text-white">
              <button
                type="button"
                onClick={() => setIsBrochureOpen(true)}
                className="mx-auto mb-2 grid h-20 w-20 place-items-center rounded-full bg-white"
                aria-label="Open virtual tour enquiry form"
              >
                <PlayIcon className="h-9 w-9 translate-x-0.5 text-slate-700" />
              </button>
              <h3 className="hidden text-4xl font-bold uppercase tracking-wide md:block">Virtual Site Visit</h3>
              <p className="hidden text-3xl md:block">The Monogram Collection</p>
            </div>
          </div>
        </section>

        <section id="developer" className={sectionClass}>
          <img
            src={projectLogo}
            alt="The Monogram Collection"
            className="mx-auto h-[60px] w-auto"
          />
          <h2 className="mt-3 text-xl font-bold">About Veena Developers</h2>
          <p className="mt-3 text-base leading-relaxed">
            Veena Developers is built on trust, transparency and a strong commitment to quality. Every new address is approached with a fresh vision and a clear goal: to set a new standard for the way people live. The Monogram Collection carries that same promise, where every detail is held to an exacting standard from the first design to the final handover.
          </p>
        </section>

        <section className={sectionClass}>
          <h2 className="text-3xl font-medium text-[#633F2A]">Frequently Asked Questions</h2>
          <div className="mt-5 space-y-3">
            {faqs.map((faq, idx) => (
              <div key={faq.q} className="overflow-hidden rounded-none bg-[#f1f1f3] shadow-sm md:rounded-2xl">
                <button
                  type="button"
                  onClick={() => setFaqOpen((p) => (p === idx ? -1 : idx))}
                  className="flex w-full items-center justify-between px-6 py-[18px] text-left text-base font-semibold"
                >
                  <span>{faq.q}</span>
                  <ChevronDownIcon className="h-5 w-5" />
                </button>
                {faqOpen === idx && (
                  <p className="border-t border-slate-300 px-5 py-4 text-sm">{faq.a}</p>
                )}
              </div>
            ))}
          </div>
        </section>

        <section className={`${sectionClass} text-sm leading-relaxed`}>
          <p>The Monogram Collection is a marketing campaign name for the project Veena Imperia, registered under MahaRERA No. PM1180002502479 (<a href="https://maharera.mahaonline.gov.in" target="_blank" rel="noreferrer" className="text-[#633F2A] underline">maharera.mahaonline.gov.in</a>). This website is marketed by an authorised marketing partner. The content is for information purposes only and does not form an offer or contract of any kind. All images are artistic representations for illustration only. Prices are subject to change without notice and units are subject to availability. We may share your details with RERA-registered brokers and may send updates to the mobile number or email registered with us. This is not the official website of the developer.</p>
          <p className="mt-3 text-center">
            Copyright © 2026
          </p>
        </section>
      </main>

      {isBrochureOpen && (
        <div className="fixed inset-0 z-[100] grid place-items-center overflow-y-auto bg-black/60 p-3">
          <div className="relative w-full max-w-[560px] overflow-hidden rounded-none bg-[#efeff1] shadow-2xl md:rounded-md">
            <button
              type="button"
              onClick={() => setIsBrochureOpen(false)}
              className="absolute right-2 top-2 grid h-9 w-9 place-items-center rounded-full border-2 border-white bg-[#633F2A] text-white"
              aria-label="Close brochure modal"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>

            <div className="bg-gradient-to-r from-[#633F2A] to-[#633F2A] px-4 py-3 text-center text-2xl font-bold text-white md:text-3xl">
              Download Brochure
            </div>

            <div className="grid gap-3 p-3 md:grid-cols-[180px_1fr]">
              <div className="hidden rounded-xl bg-[#f7f7f7] px-2 py-4 md:block">
                <h3 className="text-center text-[#633F2A]">We Promise</h3>
                <div className="mt-5 space-y-5">
                  {promiseItems.map((item) => (
                    <div key={item.label} className="text-center text-[#633F2A]">
                      <span
                        className={`nav-mi promise-mi ${item.iconClass}`}
                        aria-hidden="true"
                      />
                      <p className="mt-1 text-base leading-tight">{item.label}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="px-1 pb-1">
                {/* <img
                  src={projectLogo}
                  alt="The Monogram Collection"
                  className="mx-auto h-[48px] w-[210px] object-contain"
                /> */}
                <p className="mt-2 text-center text-base font-semibold text-slate-800 md:text-lg">
                  Register here and Avail the <span className="text-red-600">Best Offers!!</span>
                </p>

                <form className="mt-3 space-y-3" onSubmit={handleModalSubmit}>
                  <input
                    required
                    value={modalForm.name}
                    onChange={(e) => handleModalFieldChange("name", e.target.value)}
                    placeholder="Name"
                    className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-600 outline-none placeholder:text-slate-500"
                  />
                  <input
                    type="email"
                    required
                    value={modalForm.email}
                    onChange={(e) => handleModalFieldChange("email", e.target.value)}
                    placeholder="Email Address"
                    className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-600 outline-none placeholder:text-slate-500"
                  />
                  <div className="grid grid-cols-2 gap-2">
                    <select
                      value={modalForm.countryCode}
                      onChange={(e) => handleModalFieldChange("countryCode", e.target.value)}
                      className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-700 outline-none"
                    >
                      <option>India (+91)</option>
                      <option>United Arab Emirates (+971)</option>
                      <option>United States (+1)</option>
                    </select>
                    <input
                      required
                      value={modalForm.phone}
                      onChange={(e) => handleModalFieldChange("phone", e.target.value)}
                      placeholder="Mobile No"
                      className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-600 outline-none placeholder:text-slate-500"
                    />
                  </div>
                  <select
                    required
                    value={modalForm.configuration}
                    onChange={(e) => handleModalFieldChange("configuration", e.target.value)}
                    className="w-full border-b border-slate-300 bg-transparent px-2 py-1.5 text-sm text-slate-700 outline-none"
                  >
                    <option value="">Select Configuration</option>
                    <option>3.5 BHK</option>
                    <option>4 BHK</option>
                  </select>
                  <div className="flex justify-center overflow-hidden">
                    <RobotCheckbox
                      checked={modalRobotConfirmed}
                      onChange={(checked) => {
                        setModalRobotConfirmed(checked);
                        if (checked) setModalRobotError(false);
                      }}
                    />
                  </div>
                  {modalRobotError && (
                    <p className="text-center text-xs text-red-600">
                      Please confirm that you are not a robot.
                    </p>
                  )}
                  <button
                    type="submit"
                    disabled={isSubmittingModal}
                    className="cta-hover rocking-button mx-auto block rounded-md bg-[#633F2A] px-7 py-2 text-lg font-semibold text-white hover:bg-[#633F2A]"
                  >
                    {isSubmittingModal ? "Submitting..." : "Send"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Home;

